var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "profile mentors"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "prof_1" };
const _hoisted_6 = { class: "ph edit" };
const _hoisted_7 = { class: "inner" };
const _hoisted_8 = { class: "name_box" };
const _hoisted_9 = { class: "name" };
const _hoisted_10 = { class: "advice cel2" };
const _hoisted_11 = {
    key: 2,
    class: "err"
};
const _hoisted_12 = { class: "prof_ranking" };
const _hoisted_13 = {
    class: "r_1",
    style: { "padding-right": "6px" }
};
const _hoisted_14 = {
    class: "r_2",
    style: { "padding-right": "6px" }
};
const _hoisted_15 = {
    class: "r_3",
    style: { "padding-right": "6px" }
};
const _hoisted_16 = {
    class: "star",
    style: { "padding-right": "6px" }
};
const _hoisted_17 = ["data-rate"];
const _hoisted_18 = { class: "heart" };
const _hoisted_19 = { class: "prof_2" };
const _hoisted_20 = { class: "f_box" };
const _hoisted_21 = { class: "f_l" };
const _hoisted_22 = { class: "f_box" };
const _hoisted_23 = { class: "f_l" };
const _hoisted_24 = { class: "bread" };
const _hoisted_25 = { class: "f_box" };
const _hoisted_26 = { class: "f_l" };
const _hoisted_27 = { style: { "white-space": "pre-line" } };
const _hoisted_28 = { class: "f_box" };
const _hoisted_29 = { class: "f_l" };
const _hoisted_30 = { class: "f_box" };
const _hoisted_31 = { class: "f_l" };
const _hoisted_32 = { class: "f_box" };
const _hoisted_33 = { class: "f_l" };
const _hoisted_34 = { style: { "white-space": "pre-line" } };
const _hoisted_35 = { class: "f_box" };
const _hoisted_36 = { class: "f_l" };
const _hoisted_37 = { style: { "white-space": "pre-line" } };
const _hoisted_38 = { class: "f_box" };
const _hoisted_39 = { class: "f_l" };
const _hoisted_40 = { class: "f_box" };
const _hoisted_41 = { class: "f_l" };
const _hoisted_42 = { class: "f_box" };
const _hoisted_43 = { class: "f_l" };
const _hoisted_44 = { class: "f_box" };
const _hoisted_45 = { class: "f_l" };
const _hoisted_46 = { class: "f_box" };
const _hoisted_47 = { class: "f_l" };
const _hoisted_48 = { class: "f_box" };
const _hoisted_49 = {
    class: "f_l",
    style: { "white-space": "pre-line" }
};
const _hoisted_50 = { class: "f_box" };
const _hoisted_51 = {
    class: "f_l",
    style: { "white-space": "pre-line" }
};
const _hoisted_52 = { class: "f_box" };
const _hoisted_53 = {
    class: "f_l",
    style: { "white-space": "pre-line" }
};
const _hoisted_54 = { class: "must" };
const _hoisted_55 = {
    key: 0,
    class: "public"
};
const _hoisted_56 = {
    key: 1,
    class: "non_public"
};
const _hoisted_57 = { class: "under_line" };
const _hoisted_58 = { class: "f_box" };
const _hoisted_59 = { class: "f_l max" };
const _hoisted_60 = { class: "job" };
const _hoisted_61 = { class: "w100" };
const _hoisted_62 = { class: "w100" };
const _hoisted_63 = { class: "w50" };
const _hoisted_64 = { class: "w50" };
const _hoisted_65 = {
    class: "w100",
    style: { "white-space": "pre-line" }
};
const _hoisted_66 = { class: "f_r" };
const _hoisted_67 = ["onClick"];
const _hoisted_68 = ["onClick"];
const _hoisted_69 = {
    key: 0,
    class: "err",
    style: { "font-size": "1.8rem" }
};
const _hoisted_70 = { class: "min_link" };
const _hoisted_71 = {
    id: "career-delete-modal",
    class: "modal min js-modal"
};
const _hoisted_72 = { class: "modal-content" };
const _hoisted_73 = { class: "close_bt bt_modal_close" };
const _hoisted_74 = { class: "pop" };
const _hoisted_75 = { class: "bt_box clear" };
import { ref, reactive, computed, onBeforeMount, onMounted, nextTick } from 'vue';
import { isArray } from '@vue/shared';
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import ImageFrame from '@component/ImageFrame.vue';
import DisplayNameModal from '@component/Modals/EditProfile/DisplayNameModal.vue';
import IndustryModal from '@component/Modals/EditProfile/IndustryModal.vue';
import JobModal from '@component/Modals/EditProfile/JobModal.vue';
import CompanyProfileModal from '@component/Modals/EditProfile/CompanyProfileModal.vue';
import AnnualSaleModal from '@component/Modals/EditProfile/AnnualSaleModal.vue';
import EmployeeModal from '@component/Modals/EditProfile/EmployeeModal.vue';
import SelfIntroductionModal from '@component/Modals/EditProfile/SelfIntroductionModal.vue';
import SkillSummaryModal from '@component/Modals/EditProfile/SkillSummaryModal.vue';
import RealNameModal from '@component/Modals/EditProfile/RealNameModal.vue';
import KanaNameModal from '@component/Modals/EditProfile/KanaNameModal.vue';
import TelModal from '@component/Modals/EditProfile/TelModal.vue';
import AddressModal from '@component/Modals/EditProfile/AddressModal.vue';
import EducationModal from '@component/Modals/EditProfile/EducationModal.vue';
import QualificationModal from '@component/Modals/EditProfile/QualificationModal.vue';
import LanguageModal from '@component/Modals/EditProfile/LanguageModal.vue';
import IsPublicCareerModal from '@component/Modals/EditProfile/IsPublicCareerModal.vue';
import IsNotificationReceivingModal from '@component/Modals/EditProfile/IsNotificationReceivingModal.vue';
import CareerModal from '@component/Modals/EditProfile/CareerModal.vue';
import Formatter from '@util/Formatter';
import { ProfileUpdateType, QuestionType } from '@util/Consts';
import { tryJsonForObject } from '@util/Common';
const USER_HOME_SEARCH_SESSION_KEY = 'user-home-search';
// ユーザホームへ遷移
export default /*@__PURE__*/ _defineComponent({
    __name: 'my_profile_mentor',
    props: {
        common: {},
        user: {}
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
        const props = __props;
        const form = reactive({
            id: props.user.id,
            photo: props.user.photo,
            photo_file: null,
            name: props.user.name,
            industry_id: (_c = (_b = (_a = props.user) === null || _a === void 0 ? void 0 : _a.industry) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null,
            job_group_id: (_f = (_e = (_d = props.user) === null || _d === void 0 ? void 0 : _d.job_group) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : null,
            job_id: (_j = (_h = (_g = props.user) === null || _g === void 0 ? void 0 : _g.job) === null || _h === void 0 ? void 0 : _h.id) !== null && _j !== void 0 ? _j : null,
            other_job_name: (_k = props.user.other_job_name) !== null && _k !== void 0 ? _k : '',
            company_profile: (_l = props.user.company_profile) !== null && _l !== void 0 ? _l : '',
            annual_sale_id: (_p = (_o = (_m = props.user) === null || _m === void 0 ? void 0 : _m.annual_sale) === null || _o === void 0 ? void 0 : _o.id) !== null && _p !== void 0 ? _p : null,
            employee_id: (_s = (_r = (_q = props.user) === null || _q === void 0 ? void 0 : _q.employee) === null || _r === void 0 ? void 0 : _r.id) !== null && _s !== void 0 ? _s : null,
            self_introduction: (_t = props.user.self_introduction) !== null && _t !== void 0 ? _t : '',
            skill_summary: (_u = props.user.skill_summary) !== null && _u !== void 0 ? _u : '',
            real_name: (_v = props.user.real_name) !== null && _v !== void 0 ? _v : '',
            kana_name: (_w = props.user.kana_name) !== null && _w !== void 0 ? _w : '',
            tel: (_x = props.user.tel) !== null && _x !== void 0 ? _x : '',
            postal_code: (_y = props.user.postal_code) !== null && _y !== void 0 ? _y : '',
            prefecture_id: (_0 = (_z = props.user.prefecture) === null || _z === void 0 ? void 0 : _z.id) !== null && _0 !== void 0 ? _0 : null,
            city: (_1 = props.user.city) !== null && _1 !== void 0 ? _1 : '',
            building: (_2 = props.user.building) !== null && _2 !== void 0 ? _2 : '',
            education: (_3 = props.user.education) !== null && _3 !== void 0 ? _3 : '',
            qualification: (_4 = props.user.qualification) !== null && _4 !== void 0 ? _4 : '',
            language: (_5 = props.user.language) !== null && _5 !== void 0 ? _5 : '',
            is_public_career: props.user.is_public_career === 1,
            career: (_6 = props.user.careers) !== null && _6 !== void 0 ? _6 : [],
            is_notification_receiving: props.user.is_notification_receiving === 1,
        });
        const openJobModal = () => {
            var _a;
            (_a = jobModal === null || jobModal === void 0 ? void 0 : jobModal.value) === null || _a === void 0 ? void 0 : _a.openModal(form);
        };
        let careerIndex = null;
        let careerDelIndex = null;
        const career = ref({
            id: null,
            started_at: '',
            is_ended: true,
            ended_at: null,
            organization: '',
            department: '',
            position: '',
            experience_content: '',
        });
        const industryOptions = ref([]);
        const jobOptions = ref([]);
        const annualSaleOptions = ref([]);
        const employeeOptions = ref([]);
        const prefOptions = ref([]);
        const inputIconRef = ref();
        const errors = reactive({
            name: '',
            photo: '',
            industry: '',
            job_id: '',
            other_job_name: '',
            self_introduction: '',
            skill_summary: '',
            real_name: '',
            kana_name: '',
            tel: '',
            postal_code: '',
            prefecture_id: '',
            city: '',
            building: '',
            undeleted_career: '',
            is_public_career: '',
            started_at: '',
            is_ended: '',
            ended_at: '',
            organization: '',
            department: '',
            position: '',
            experience_content: '',
            is_notification_receiving: '',
        });
        // 更新処理中か判定
        const processing = ref(false);
        // モーダル
        const displayNameModal = ref();
        const industryModal = ref();
        const jobModal = ref();
        const companyProfileModal = ref();
        const annualSaleModal = ref();
        const employeeModal = ref();
        const selfIntroductionModal = ref();
        const skillSummaryModal = ref();
        const realNameModal = ref();
        const kanaNameModal = ref();
        const telModal = ref();
        const addressModal = ref();
        const educationModal = ref();
        const qualificationModal = ref();
        const languageModal = ref();
        const isPublicCareerModal = ref();
        const isNotificationReceivingModal = ref();
        const careerDeleteModal = ref();
        const careerModal = ref();
        const selectedIndustry = computed(() => {
            return getOptionName(form.industry_id, industryOptions.value);
        });
        const selectedJob = computed(() => {
            var _a, _b, _c, _d;
            if ((form.job_group_id === null || form.job_group_id === '') && form.other_job_name) {
                return ['その他', form.other_job_name];
            }
            const jobGroup = (_b = (_a = jobOptions.value) === null || _a === void 0 ? void 0 : _a.find((value) => value.id === form.job_group_id)) !== null && _b !== void 0 ? _b : null;
            const job = (_d = (_c = jobGroup === null || jobGroup === void 0 ? void 0 : jobGroup.jobs) === null || _c === void 0 ? void 0 : _c.find((value) => value.id === form.job_id)) !== null && _d !== void 0 ? _d : null;
            const result = [];
            if (jobGroup === null || jobGroup === void 0 ? void 0 : jobGroup.name) {
                result.push(jobGroup.name);
            }
            if (job === null || job === void 0 ? void 0 : job.name) {
                result.push(job.name);
            }
            if (form.other_job_name) {
                result.push(form.other_job_name);
            }
            return result;
        });
        const selectedAnnualSale = computed(() => {
            return getOptionName(form.annual_sale_id, annualSaleOptions.value);
        });
        const selectedEmployee = computed(() => {
            return getOptionName(form.employee_id, employeeOptions.value);
        });
        const selectedPrefecture = computed(() => {
            return getOptionName(form.prefecture_id, prefOptions.value);
        });
        const getOptionName = (id, options) => {
            var _a, _b;
            if (isArray(options)) {
                const option = (_a = options === null || options === void 0 ? void 0 : options.find((value) => value.id === id)) !== null && _a !== void 0 ? _a : null;
                return (_b = option === null || option === void 0 ? void 0 : option.name) !== null && _b !== void 0 ? _b : '';
            }
            return '';
        };
        // 表示名入力イベント
        const onInputDisplayName = (value) => {
            const param = {
                update_type: ProfileUpdateType.NAME,
                name: value,
            };
            onSave(param, () => {
                form.name = value;
                displayNameModal.value.onCloseModal();
            });
        };
        // 業種選択イベント
        const onSelectedIndustry = (id) => {
            const param = {
                update_type: ProfileUpdateType.INDUSTRY,
                industry_id: id,
            };
            onSave(param, () => {
                form.industry_id = id;
                industryModal.value.onCloseModal();
            });
        };
        // 職種選択イベント
        const onSelectedJob = (job) => {
            const param = {
                update_type: ProfileUpdateType.JOB,
                job_id: job.job_id,
                other_job_name: job.other_job_name,
            };
            onSave(param, () => {
                form.job_group_id = job.job_group_id;
                form.job_id = job.job_id;
                form.other_job_name = job.other_job_name;
                jobModal.value.onCloseModal();
            });
        };
        // 会社概要入力イベント
        const onInputCompanyProfile = (value) => {
            const param = {
                update_type: ProfileUpdateType.COMPANY_PROFILE,
                company_profile: value,
            };
            onSave(param, () => {
                form.company_profile = value;
                companyProfileModal.value.onCloseModal();
            });
        };
        // 年商選択イベント
        const onSelectedAnnualSale = (id) => {
            const param = {
                update_type: ProfileUpdateType.ANNUAL_SALE,
                annual_sale_id: id,
            };
            onSave(param, () => {
                form.annual_sale_id = id;
                annualSaleModal.value.onCloseModal();
            });
        };
        // 社員数選択イベント
        const onSelectedEmployee = (id) => {
            const param = {
                update_type: ProfileUpdateType.EMPLOYEE,
                employee_id: id,
            };
            onSave(param, () => {
                form.employee_id = id;
                employeeModal.value.onCloseModal();
            });
        };
        // 自己紹介入力イベント
        const onInputSelfIntroduction = (value) => {
            const param = {
                update_type: ProfileUpdateType.SELF_INTRODUCTION,
                self_introduction: value,
            };
            onSave(param, () => {
                form.self_introduction = value;
                selfIntroductionModal.value.onCloseModal();
            });
        };
        // スキル要約入力イベント
        const onInputSkillSummary = (value) => {
            const param = {
                update_type: ProfileUpdateType.SKILL_SUMMARY,
                skill_summary: value,
            };
            onSave(param, () => {
                form.skill_summary = value;
                skillSummaryModal.value.onCloseModal();
            });
        };
        // 氏名（本名）入力イベント
        const onInputRealName = (value) => {
            const param = {
                update_type: ProfileUpdateType.REAL_NAME,
                real_name: value,
            };
            onSave(param, () => {
                form.real_name = value;
                realNameModal.value.onCloseModal();
            });
        };
        // 氏名（カナ）入力イベント
        const onInputKanaName = (value) => {
            const param = {
                update_type: ProfileUpdateType.KANA_NAME,
                kana_name: value,
            };
            onSave(param, () => {
                form.kana_name = value;
                kanaNameModal.value.onCloseModal();
            });
        };
        // 電話番号入力イベント
        const onInputTel = (value) => {
            const param = {
                update_type: ProfileUpdateType.TEL,
                tel: value,
            };
            onSave(param, () => {
                form.tel = value;
                telModal.value.onCloseModal();
            });
        };
        // 住所入力イベント
        const onInputAddress = (address) => {
            const param = {
                update_type: ProfileUpdateType.ADDRESS,
                postal_code: address.postal_code,
                prefecture_id: address.prefecture_id,
                city: address.city,
                building: address.building,
            };
            onSave(param, () => {
                form.postal_code = address.postal_code;
                form.prefecture_id = address.prefecture_id;
                form.city = address.city;
                form.building = address.building;
                addressModal.value.onCloseModal();
            });
        };
        // 最終学歴入力イベント
        const onInputEducation = (value) => {
            const param = {
                update_type: ProfileUpdateType.EDUCATION,
                education: value,
            };
            onSave(param, () => {
                form.education = value;
                educationModal.value.onCloseModal();
            });
        };
        // 資格入力イベント
        const onInputQualification = (value) => {
            const param = {
                update_type: ProfileUpdateType.QUALIFICATION,
                qualification: value,
            };
            onSave(param, () => {
                form.qualification = value;
                qualificationModal.value.onCloseModal();
            });
        };
        // 語学入力イベント
        const onInputLanguage = (value) => {
            const param = {
                update_type: ProfileUpdateType.LANGUAGE,
                language: value,
            };
            onSave(param, () => {
                form.language = value;
                languageModal.value.onCloseModal();
            });
        };
        // 推薦状の有無入力イベント
        const onSelectedIsNotificationReceiving = (value) => {
            const param = {
                update_type: ProfileUpdateType.IS_NOTIFICATION_RECEIVING,
                is_notification_receiving: value,
            };
            onSave(param, () => {
                form.is_notification_receiving = value;
                isNotificationReceivingModal.value.onCloseModal();
            });
        };
        // 職歴公開フラグ選択イベント
        const onSelectedIsPublicCareer = (value) => {
            const param = {
                update_type: ProfileUpdateType.CAREER_PUBLIC_SETTING,
                is_public_career: value,
            };
            onSave(param, () => {
                form.is_public_career = value;
                isPublicCareerModal.value.onCloseModal();
            });
        };
        // 職歴削除モーダルの表示イベント
        const onOpenCareerDelModal = (index) => {
            careerDelIndex = index;
        };
        // 職歴削除
        const onDeleteCareer = () => {
            if (typeof careerDelIndex !== 'number' && !careerDelIndex)
                return;
            if (form.career.length <= 1) {
                setErrors(ProfileUpdateType.CAREER_DELETE, '職歴が１つの場合は削除できません');
                return;
            }
            else {
                setErrors(ProfileUpdateType.CAREER_DELETE, '');
            }
            const param = {
                update_type: ProfileUpdateType.CAREER_DELETE,
                career_id: form.career[careerDelIndex].id,
            };
            onSave(param, (response) => {
                const careers = response.data.user.careers;
                form.career = careers;
                careerDeleteModal.value.click();
            });
        };
        // 職歴モーダルの表示イベント
        const onOpenCareerModal = (value, index) => {
            if (value && index !== undefined) {
                // 選択した職歴の編集
                careerIndex = index;
                career.value = value;
                career.value.started_at = Formatter.formatDate(career.value.started_at, 'YYYY/MM');
                let endedAt = Formatter.formatDate(career.value.ended_at, 'YYYY/MM');
                career.value.ended_at = endedAt;
                career.value.is_ended = endedAt.trim() == '';
            }
            else {
                // 職歴の追加
                careerIndex = null;
                career.value = {
                    id: null,
                    started_at: '',
                    is_ended: true,
                    ended_at: null,
                    organization: '',
                    department: '',
                    position: '',
                    experience_content: '',
                };
            }
        };
        // 職歴モーダルの入力が完了した時のイベント
        const onInputCareerModal = (value) => {
            let param = null;
            if (careerIndex !== null) {
                param = {
                    update_type: ProfileUpdateType.CAREER_UPDATE,
                    career_id: value.id,
                    started_at: value.started_at,
                    is_ended: value.is_ended,
                    ended_at: value.ended_at,
                    organization: value.organization,
                    department: value.department,
                    position: value.position,
                    experience_content: value.experience_content,
                };
            }
            else {
                param = {
                    update_type: ProfileUpdateType.CAREER_CREATE,
                    // career_id: null,
                    started_at: value.started_at,
                    is_ended: value.is_ended,
                    ended_at: value.ended_at,
                    organization: value.organization,
                    department: value.department,
                    position: value.position,
                    experience_content: value.experience_content,
                };
            }
            onSave(param, (response) => {
                const careers = response.data.user.careers;
                form.career = careers;
                if (careerIndex === null) {
                    nextTick(() => {
                        // 既に読み込まれていたら一旦削除して、読み込み直す。
                        var key = require.resolve('@jquery/modal-jquery');
                        if (key)
                            delete require.cache[key];
                        require('@jquery/modal-jquery');
                    });
                }
                careerModal.value.onCloseModal();
            });
        };
        const onClickUserHome = () => {
            var _a;
            let searchForm = JSON.parse(sessionStorage.getItem(USER_HOME_SEARCH_SESSION_KEY));
            if (searchForm) {
                searchForm.question_type_id = "";
                searchForm.industry_id = "";
                searchForm.job_group_id = "";
                searchForm.job_group_name = "";
                searchForm.job_id = "";
                searchForm.other_job_name = "";
                searchForm.option_type = "4";
                searchForm.keyword = `user:${(_a = props.user) === null || _a === void 0 ? void 0 : _a.id}`;
                sessionStorage.setItem(USER_HOME_SEARCH_SESSION_KEY, JSON.stringify(searchForm));
            }
            Inertia.get(route('question.index'), { option_type: QuestionType.HIGHLY_RATED, keyword: `user:${form.id}` });
        };
        const isDeleteShow = reactive({ shot: (_8 = (_7 = props.user.photo) === null || _7 === void 0 ? void 0 : _7.includes('user/icon')) !== null && _8 !== void 0 ? _8 : false });
        const deleteImage = () => {
            const isDelete = confirm('削除してもよろしいでしょうか?');
            if (!isDelete)
                return;
            isDeleteShow.shot = false;
            Inertia.delete(route('profile.delete', { id: form.id }));
            form.photo = 'images/user/default.svg';
        };
        // アイコン選択ダイアログ表示
        const openIconDialog = () => {
            inputIconRef.value.click();
        };
        // アイコン選択イベント
        const onChangeIcon = (event) => {
            const file = event.target.files[0];
            event.target.value = null;
            const url = URL.createObjectURL(file);
            const param = new FormData();
            param.append("photo_file", file);
            param.append("update_type", ProfileUpdateType.PHOTO);
            onSave(param, () => {
                form.photo_file = file;
                form.photo = url;
                isDeleteShow.shot = form.photo_file ? true : false;
            });
        };
        const onSave = (param, onSuccess) => {
            if (processing.value)
                return;
            processing.value = true;
            // 画像の場合にコンテントタイプを変更する
            let contentType = 'application/json';
            if (param.update_type === ProfileUpdateType.PHOTO) {
                contentType = 'multipart/form-data';
            }
            axios.post(route('mentor.profile.update'), param, {
                headers: {
                    'content-type': contentType,
                }
            }).then(response => {
                var _a, _b;
                const res = tryJsonForObject(response);
                if ((res === null || res === void 0 ? void 0 : res.status) === 422) {
                    const errors = JSON.parse(response.request.response);
                    setErrors(param.update_type, (_a = errors === null || errors === void 0 ? void 0 : errors.message) !== null && _a !== void 0 ? _a : '', (_b = errors === null || errors === void 0 ? void 0 : errors.errors) !== null && _b !== void 0 ? _b : null);
                    if (errors.errors.photo_file) {
                        alert(errors.message);
                        location.reload();
                    }
                    ;
                }
                else if ((res === null || res === void 0 ? void 0 : res.status) === 200) {
                    onSuccess(response);
                    setErrors(param.update_type, '');
                }
            }).finally(() => { processing.value = false; });
        };
        const setErrors = (type, message, error) => {
            var _a, _b;
            switch (type) {
                case ProfileUpdateType.NAME:
                    errors.name = message;
                    break;
                case ProfileUpdateType.PHOTO:
                    errors.photo = message;
                    break;
                case ProfileUpdateType.INDUSTRY:
                    errors.industry = message;
                    break;
                case ProfileUpdateType.JOB:
                    errors.job_id = (_a = error === null || error === void 0 ? void 0 : error.job_id[0]) !== null && _a !== void 0 ? _a : '';
                    errors.other_job_name = (_b = error === null || error === void 0 ? void 0 : error.other_job_name[0]) !== null && _b !== void 0 ? _b : '';
                    break;
                case ProfileUpdateType.SELF_INTRODUCTION:
                    errors.self_introduction = message;
                    break;
                case ProfileUpdateType.SKILL_SUMMARY:
                    errors.skill_summary = message;
                    break;
                case ProfileUpdateType.REAL_NAME:
                    errors.real_name = message;
                    break;
                case ProfileUpdateType.KANA_NAME:
                    errors.kana_name = message;
                    break;
                case ProfileUpdateType.TEL:
                    errors.tel = message;
                    break;
                case ProfileUpdateType.ADDRESS:
                    errors.postal_code = (error === null || error === void 0 ? void 0 : error.postal_code) ? error === null || error === void 0 ? void 0 : error.postal_code[0] : '';
                    errors.prefecture_id = (error === null || error === void 0 ? void 0 : error.prefecture_id) ? error === null || error === void 0 ? void 0 : error.prefecture_id[0] : '';
                    errors.city = (error === null || error === void 0 ? void 0 : error.city) ? error === null || error === void 0 ? void 0 : error.city[0] : '';
                    errors.building = (error === null || error === void 0 ? void 0 : error.building) ? error === null || error === void 0 ? void 0 : error.building[0] : '';
                    break;
                case ProfileUpdateType.CAREER_PUBLIC_SETTING:
                    errors.is_public_career = message;
                    break;
                case ProfileUpdateType.CAREER_DELETE:
                    errors.undeleted_career = message;
                    break;
                case ProfileUpdateType.CAREER_CREATE:
                case ProfileUpdateType.CAREER_UPDATE:
                    errors.undeleted_career = '';
                    errors.started_at = (error === null || error === void 0 ? void 0 : error.started_at) ? error === null || error === void 0 ? void 0 : error.started_at[0] : '';
                    errors.is_ended = (error === null || error === void 0 ? void 0 : error.is_ended) ? error === null || error === void 0 ? void 0 : error.is_ended[0] : '';
                    errors.ended_at = (error === null || error === void 0 ? void 0 : error.ended_at) ? error === null || error === void 0 ? void 0 : error.ended_at[0] : '';
                    errors.organization = (error === null || error === void 0 ? void 0 : error.organization) ? error === null || error === void 0 ? void 0 : error.organization[0] : '';
                    errors.department = (error === null || error === void 0 ? void 0 : error.department) ? error === null || error === void 0 ? void 0 : error.department[0] : '';
                    errors.position = (error === null || error === void 0 ? void 0 : error.position) ? error === null || error === void 0 ? void 0 : error.position[0] : '';
                    errors.experience_content = (error === null || error === void 0 ? void 0 : error.experience_content) ? error === null || error === void 0 ? void 0 : error.experience_content[0] : '';
                    break;
                default: break;
            }
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            try {
                const [industries, jobs, annualSales, employees, prefectures] = yield Promise.all([
                    axios.get('/industries').then(res => res.data).catch(e => {
                        console.error('Failed to load industries:', e);
                        return [];
                    }),
                    axios.get('/jobs').then(res => res.data).catch(e => {
                        console.error('Failed to load jobs:', e);
                        return [];
                    }),
                    axios.get('/annual-sales').then(res => res.data).catch(e => {
                        console.error('Failed to load annual-sales:', e);
                        return [];
                    }),
                    axios.get('/employees').then(res => res.data).catch(e => {
                        console.error('Failed to load employees:', e);
                        return [];
                    }),
                    axios.get('/prefectures').then(res => res.data).catch(e => {
                        console.error('Failed to load prefectures:', e);
                        return [];
                    }),
                ]);
                industryOptions.value = industries;
                jobOptions.value = jobs;
                annualSaleOptions.value = annualSales;
                employeeOptions.value = employees;
                prefOptions.value = prefectures;
                console.log('Loaded data:', { industries, jobs, annualSales, employees, prefectures });
            }
            catch (error) {
                console.error('Error in onBeforeMount:', error);
            }
        }));
        onMounted(() => {
            nextTick(() => {
                var key = require.resolve('@jquery/datepicker-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/datepicker-jquery');
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common,
                    photo: form.photo
                }, null, 8, ["common", "photo"]),
                _cache[80] || (_cache[80] = _createElementVNode("iframe", {
                    style: { "display": "none" },
                    onload: "resizeTextarea('company_profile',7),resizeTextarea('self-introduction',7),resizeTextarea('skill-summary',7),resizeTextarea('experience-content',7)"
                }, null, -1)),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[76] || (_cache[76] = _createElementVNode("h2", null, "プロフィール", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("input", {
                                            ref_key: "inputIconRef",
                                            ref: inputIconRef,
                                            type: "file",
                                            accept: ".jpeg,.jpg,.gif,.png",
                                            onChange: onChangeIcon,
                                            style: { "display": "none" }
                                        }, null, 544),
                                        _createElementVNode("a", {
                                            class: "bt_change",
                                            onClick: _withModifiers(openIconDialog, ["prevent"])
                                        }),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createVNode(ImageFrame, {
                                                src: form === null || form === void 0 ? void 0 : form.photo
                                            }, null, 8, ["src"])
                                        ])
                                    ]),
                                    (isDeleteShow.shot)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            class: "bt_delete del-sp",
                                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (deleteImage()), ["prevent"]))
                                        }, "画像削除"))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_8, [
                                        _cache[22] || (_cache[22] = _createTextVNode(" 表示名")),
                                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "must" }, "必須", -1)),
                                        _cache[24] || (_cache[24] = _createElementVNode("span", { class: "public" }, "公開", -1)),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createTextVNode(_toDisplayString(form.name), 1),
                                            _cache[21] || (_cache[21] = _createElementVNode("a", {
                                                class: "bt_change modal_win",
                                                "data-target": "display-name-modal"
                                            }, "変更", -1))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(onClickUserHome, ["prevent"]),
                                            style: { "margin-right": "6px" }
                                        }, [
                                            _cache[26] || (_cache[26] = _createTextVNode("相談")),
                                            _createElementVNode("p", null, [
                                                _createElementVNode("span", null, _toDisplayString(props.user.question_count), 1),
                                                _cache[25] || (_cache[25] = _createTextVNode("件"))
                                            ])
                                        ]),
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(onClickUserHome, ["prevent"])
                                        }, [
                                            _cache[28] || (_cache[28] = _createTextVNode("回答")),
                                            _createElementVNode("p", null, [
                                                _createElementVNode("span", null, _toDisplayString(props.user.answer_count), 1),
                                                _cache[27] || (_cache[27] = _createTextVNode("件"))
                                            ])
                                        ])
                                    ]),
                                    (isDeleteShow.shot)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            class: "bt_delete del-pc",
                                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (deleteImage()), ["prevent"]))
                                        }, "画像削除"))
                                        : _createCommentVNode("", true),
                                    (errors === null || errors === void 0 ? void 0 : errors.photo)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errors.photo), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("p", _hoisted_13, _toDisplayString((_a = props.user.first_place_count) !== null && _a !== void 0 ? _a : 0), 1),
                                    _createElementVNode("p", _hoisted_14, _toDisplayString((_b = props.user.second_place_count) !== null && _b !== void 0 ? _b : 0), 1),
                                    _createElementVNode("p", _hoisted_15, _toDisplayString((_c = props.user.third_place_count) !== null && _c !== void 0 ? _c : 0), 1),
                                    _createElementVNode("p", _hoisted_16, [
                                        _cache[29] || (_cache[29] = _createTextVNode("評価")),
                                        _createElementVNode("span", {
                                            class: "star5_rating",
                                            "data-rate": (_d = props.user.evaluation_average) !== null && _d !== void 0 ? _d : 0
                                        }, null, 8, _hoisted_17)
                                    ]),
                                    _createElementVNode("p", _hoisted_18, [
                                        _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fas fa-heart" }, null, -1)),
                                        _createTextVNode(_toDisplayString((_e = props.user.like_count) !== null && _e !== void 0 ? _e : 0), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("dl", null, [
                                        _cache[61] || (_cache[61] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 業種<br class=\"pc\" data-v-2f1fb118><span class=\"must\" data-v-2f1fb118>必須</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"industry-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, _toDisplayString(selectedIndustry.value), 1),
                                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "industry-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _createElementVNode("dt", { class: "must" }, [
                                            _cache[32] || (_cache[32] = _createTextVNode(" 職種")),
                                            _cache[33] || (_cache[33] = _createElementVNode("br", { class: "pc" }, null, -1)),
                                            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "must" }, "必須", -1)),
                                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "public" }, "公開", -1)),
                                            _createElementVNode("a", {
                                                class: "bt_change modal_win sp",
                                                "data-target": "job-modal",
                                                onClick: openJobModal
                                            }, "変更")
                                        ]),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("ul", _hoisted_24, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedJob.value, (name) => {
                                                            return (_openBlock(), _createElementBlock("li", null, _toDisplayString(name), 1));
                                                        }), 256))
                                                    ])
                                                ]),
                                                _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "job-modal",
                                                        onClick: openJobModal
                                                    }, "変更")
                                                ])
                                            ])
                                        ]),
                                        _cache[62] || (_cache[62] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 会社概要<br class=\"pc\" data-v-2f1fb118><span class=\"optionally\" data-v-2f1fb118>任意</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"company-profile-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_25, [
                                                _createElementVNode("div", _hoisted_26, [
                                                    _createElementVNode("p", _hoisted_27, _toDisplayString(form.company_profile), 1)
                                                ]),
                                                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "company-profile-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[63] || (_cache[63] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 年商<br class=\"pc\" data-v-2f1fb118><span class=\"optionally\" data-v-2f1fb118>任意</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"annual-sale-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, _toDisplayString(selectedAnnualSale.value), 1),
                                                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "annual-sale-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[64] || (_cache[64] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 社員数<br class=\"pc\" data-v-2f1fb118><span class=\"optionally\" data-v-2f1fb118>任意</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"employee-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_30, [
                                                _createElementVNode("div", _hoisted_31, _toDisplayString(selectedEmployee.value), 1),
                                                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "employee-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[65] || (_cache[65] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 自己紹介<br class=\"pc\" data-v-2f1fb118><span class=\"must\" data-v-2f1fb118>必須</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"self-introduction-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("p", _hoisted_34, _toDisplayString(form.self_introduction), 1)
                                                ]),
                                                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "self-introduction-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[66] || (_cache[66] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> スキル要約<br class=\"pc\" data-v-2f1fb118><span class=\"must\" data-v-2f1fb118>必須</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"skill-summary-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_35, [
                                                _createElementVNode("div", _hoisted_36, [
                                                    _createElementVNode("p", _hoisted_37, _toDisplayString(form.skill_summary), 1)
                                                ]),
                                                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "skill-summary-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[67] || (_cache[67] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 氏名（本名）<br class=\"pc\" data-v-2f1fb118><span class=\"must\" data-v-2f1fb118>必須</span><span class=\"non_public\" data-v-2f1fb118>非公開</span><a class=\"bt_change modal_win sp\" data-target=\"real-name-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _createElementVNode("div", _hoisted_39, _toDisplayString(form.real_name), 1),
                                                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "real-name-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[68] || (_cache[68] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 氏名（カナ）<br class=\"pc\" data-v-2f1fb118><span class=\"must\" data-v-2f1fb118>必須</span><span class=\"non_public\" data-v-2f1fb118>非公開</span><a class=\"bt_change modal_win sp\" data-target=\"kana-name-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_40, [
                                                _createElementVNode("div", _hoisted_41, _toDisplayString(form.kana_name), 1),
                                                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "kana-name-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[69] || (_cache[69] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 連絡先ＴＥＬ<br class=\"pc\" data-v-2f1fb118><span class=\"must\" data-v-2f1fb118>必須</span><span class=\"non_public\" data-v-2f1fb118>非公開</span><a class=\"bt_change modal_win sp\" data-target=\"tel-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_42, [
                                                _createElementVNode("div", _hoisted_43, _toDisplayString(form.tel), 1),
                                                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "tel-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[70] || (_cache[70] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 連絡先住所<br class=\"pc\" data-v-2f1fb118><span class=\"must\" data-v-2f1fb118>必須</span><span class=\"non_public\" data-v-2f1fb118>非公開</span><a class=\"bt_change modal_win sp\" data-target=\"address-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("div", _hoisted_45, [
                                                    _createTextVNode(" 〒" + _toDisplayString(form.postal_code), 1),
                                                    _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
                                                    _createTextVNode(_toDisplayString(selectedPrefecture.value) + _toDisplayString(form.city), 1),
                                                    _cache[45] || (_cache[45] = _createElementVNode("br", { class: "pc" }, null, -1)),
                                                    _createTextVNode(" " + _toDisplayString(form.building), 1)
                                                ]),
                                                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "address-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[71] || (_cache[71] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 最終学歴<br class=\"pc\" data-v-2f1fb118><span class=\"optionally\" data-v-2f1fb118>任意</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"education-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_46, [
                                                _createElementVNode("div", _hoisted_47, _toDisplayString(form.education), 1),
                                                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "education-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[72] || (_cache[72] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 資格<br class=\"pc\" data-v-2f1fb118><span class=\"optionally\" data-v-2f1fb118>任意</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"qualification-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_48, [
                                                _createElementVNode("div", _hoisted_49, _toDisplayString(form.qualification), 1),
                                                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "qualification-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[73] || (_cache[73] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 語学<br class=\"pc\" data-v-2f1fb118><span class=\"optionally\" data-v-2f1fb118>任意</span><span class=\"public\" data-v-2f1fb118>公開</span><a class=\"bt_change modal_win sp\" data-target=\"language-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_50, [
                                                _createElementVNode("div", _hoisted_51, _toDisplayString(form.language), 1),
                                                _cache[49] || (_cache[49] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "language-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _cache[74] || (_cache[74] = _createStaticVNode("<dt class=\"must\" data-v-2f1fb118> 推薦状の有無<br class=\"pc\" data-v-2f1fb118><span class=\"optionally\" data-v-2f1fb118>任意</span><span class=\"non_public\" data-v-2f1fb118>非公開</span><a class=\"bt_change modal_win sp\" data-target=\"is-notification-receiving-modal\" data-v-2f1fb118>変更</a></dt>", 1)),
                                        _createElementVNode("dd", null, [
                                            _createElementVNode("div", _hoisted_52, [
                                                _createElementVNode("div", _hoisted_53, _toDisplayString(form.is_notification_receiving ? '推薦を受けました' : '推薦を受けていません'), 1),
                                                _cache[50] || (_cache[50] = _createElementVNode("div", { class: "f_r" }, [
                                                    _createElementVNode("a", {
                                                        class: "bt_change modal_win pc",
                                                        "data-target": "is-notification-receiving-modal"
                                                    }, "変更")
                                                ], -1))
                                            ])
                                        ]),
                                        _createElementVNode("dt", _hoisted_54, [
                                            _cache[51] || (_cache[51] = _createTextVNode(" 職歴")),
                                            _cache[52] || (_cache[52] = _createElementVNode("br", { class: "pc" }, null, -1)),
                                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "must" }, "必須", -1)),
                                            (form.is_public_career)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_55, "公開"))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_56, "非公開")),
                                            _cache[54] || (_cache[54] = _createElementVNode("br", { class: "pc" }, null, -1)),
                                            _cache[55] || (_cache[55] = _createElementVNode("a", {
                                                class: "bt_change modal_win",
                                                "data-target": "is-public-career-modal"
                                            }, "公開変更", -1))
                                        ]),
                                        _createElementVNode("dd", _hoisted_57, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.career, (value, index) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                    _createElementVNode("div", _hoisted_59, [
                                                        _createElementVNode("div", _hoisted_60, [
                                                            _createElementVNode("div", _hoisted_61, [
                                                                _cache[56] || (_cache[56] = _createElementVNode("p", { class: "sub_t" }, "期間", -1)),
                                                                _createTextVNode(" " + _toDisplayString(_unref(Formatter).formatCareerPeriod(value.started_at, value.ended_at)), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_62, [
                                                                _cache[57] || (_cache[57] = _createElementVNode("p", { class: "sub_t" }, "組織", -1)),
                                                                _createTextVNode(" " + _toDisplayString(value.organization), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_63, [
                                                                _cache[58] || (_cache[58] = _createElementVNode("p", { class: "sub_t" }, "部署", -1)),
                                                                _createTextVNode(" " + _toDisplayString(value.department), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_64, [
                                                                _cache[59] || (_cache[59] = _createElementVNode("p", { class: "sub_t" }, "役職", -1)),
                                                                _createTextVNode(" " + _toDisplayString(value.position), 1)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_65, [
                                                                _cache[60] || (_cache[60] = _createElementVNode("p", { class: "sub_t" }, "経験内容", -1)),
                                                                _createTextVNode(" " + _toDisplayString(value.experience_content), 1)
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_66, [
                                                        _createElementVNode("a", {
                                                            class: "bt_change modal_win",
                                                            "data-target": "career-delete-modal",
                                                            onClick: _withModifiers(($event) => (onOpenCareerDelModal(index)), ["prevent"])
                                                        }, "削除", 8, _hoisted_67),
                                                        _createElementVNode("a", {
                                                            class: "bt_change modal_win",
                                                            "data-target": "career-modal",
                                                            onClick: _withModifiers(($event) => (onOpenCareerModal(value, index)), ["prevent"])
                                                        }, "変更", 8, _hoisted_68)
                                                    ])
                                                ]));
                                            }), 256)),
                                            (errors === null || errors === void 0 ? void 0 : errors.undeleted_career)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(errors.undeleted_career), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("a", {
                                                class: "bt_change modal_win",
                                                "data-target": "career-modal",
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (onOpenCareerModal()), ["prevent"])),
                                                style: { "margin-top": "30px" }
                                            }, "追加")
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                                _createVNode(_unref(Link), {
                                    href: _ctx.route('account.leave.show')
                                }, {
                                    default: _withCtx(() => _cache[75] || (_cache[75] = [
                                        _createTextVNode("退会申請")
                                    ])),
                                    _: 1,
                                    __: [75]
                                }, 8, ["href"])
                            ])
                        ])
                    ]),
                    _createElementVNode("form", null, [
                        _createVNode(DisplayNameModal, {
                            value: form.name,
                            errors: errors.name,
                            onInput: onInputDisplayName,
                            onCancel: _cache[3] || (_cache[3] = ($event) => (setErrors(_unref(ProfileUpdateType).NAME, ''))),
                            ref_key: "displayNameModal",
                            ref: displayNameModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(IndustryModal, {
                            options: industryOptions.value,
                            id: (_f = form.industry_id) !== null && _f !== void 0 ? _f : undefined,
                            errors: errors.industry,
                            onSelected: onSelectedIndustry,
                            onCancel: _cache[4] || (_cache[4] = ($event) => (setErrors(_unref(ProfileUpdateType).INDUSTRY, ''))),
                            ref_key: "industryModal",
                            ref: industryModal
                        }, null, 8, ["options", "id", "errors"]),
                        _createVNode(JobModal, {
                            options: jobOptions.value,
                            form: form,
                            errors: { job_id: errors.job_id, other_job_name: errors.other_job_name },
                            onSelected: onSelectedJob,
                            onCancel: _cache[5] || (_cache[5] = ($event) => (setErrors(_unref(ProfileUpdateType).JOB, { job_id: '', other_job_name: '' }))),
                            ref_key: "jobModal",
                            ref: jobModal
                        }, null, 8, ["options", "form", "errors"]),
                        _createVNode(CompanyProfileModal, {
                            value: form.company_profile,
                            onInput: onInputCompanyProfile,
                            onCancel: _cache[6] || (_cache[6] = ($event) => (setErrors(_unref(ProfileUpdateType).COMPANY_PROFILE, ''))),
                            ref_key: "companyProfileModal",
                            ref: companyProfileModal
                        }, null, 8, ["value"]),
                        _createVNode(AnnualSaleModal, {
                            options: annualSaleOptions.value,
                            id: (_g = form.annual_sale_id) !== null && _g !== void 0 ? _g : undefined,
                            onSelected: onSelectedAnnualSale,
                            onCancel: _cache[7] || (_cache[7] = ($event) => (setErrors(_unref(ProfileUpdateType).ANNUAL_SALE, ''))),
                            ref_key: "annualSaleModal",
                            ref: annualSaleModal
                        }, null, 8, ["options", "id"]),
                        _createVNode(EmployeeModal, {
                            options: employeeOptions.value,
                            id: (_h = form.employee_id) !== null && _h !== void 0 ? _h : undefined,
                            onSelected: onSelectedEmployee,
                            onCancel: _cache[8] || (_cache[8] = ($event) => (setErrors(_unref(ProfileUpdateType).EMPLOYEE, ''))),
                            ref_key: "employeeModal",
                            ref: employeeModal
                        }, null, 8, ["options", "id"]),
                        _createVNode(SelfIntroductionModal, {
                            value: form.self_introduction,
                            errors: errors.self_introduction,
                            onInput: onInputSelfIntroduction,
                            onCancel: _cache[9] || (_cache[9] = ($event) => (setErrors(_unref(ProfileUpdateType).SELF_INTRODUCTION, ''))),
                            ref_key: "selfIntroductionModal",
                            ref: selfIntroductionModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(SkillSummaryModal, {
                            value: form.skill_summary,
                            errors: errors.skill_summary,
                            onInput: onInputSkillSummary,
                            onCancel: _cache[10] || (_cache[10] = ($event) => (setErrors(_unref(ProfileUpdateType).SKILL_SUMMARY, ''))),
                            ref_key: "skillSummaryModal",
                            ref: skillSummaryModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(RealNameModal, {
                            value: form.real_name,
                            errors: errors.real_name,
                            onInput: onInputRealName,
                            onCancel: _cache[11] || (_cache[11] = ($event) => (setErrors(_unref(ProfileUpdateType).REAL_NAME, ''))),
                            ref_key: "realNameModal",
                            ref: realNameModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(KanaNameModal, {
                            value: form.kana_name,
                            errors: errors.kana_name,
                            onInput: onInputKanaName,
                            onCancel: _cache[12] || (_cache[12] = ($event) => (setErrors(_unref(ProfileUpdateType).KANA_NAME, ''))),
                            ref_key: "kanaNameModal",
                            ref: kanaNameModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(TelModal, {
                            value: form.tel,
                            errors: errors.tel,
                            onInput: onInputTel,
                            onCancel: _cache[13] || (_cache[13] = ($event) => (setErrors(_unref(ProfileUpdateType).TEL, ''))),
                            ref_key: "telModal",
                            ref: telModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(AddressModal, {
                            options: prefOptions.value,
                            form: form,
                            errors: { postal_code: errors.postal_code, prefecture_id: errors.prefecture_id, city: errors.city, building: errors.building },
                            onInput: onInputAddress,
                            onCancel: _cache[14] || (_cache[14] = ($event) => (setErrors(_unref(ProfileUpdateType).ADDRESS, ''))),
                            ref_key: "addressModal",
                            ref: addressModal
                        }, null, 8, ["options", "form", "errors"]),
                        _createVNode(EducationModal, {
                            value: form.education,
                            onInput: onInputEducation,
                            onCancel: _cache[15] || (_cache[15] = ($event) => (setErrors(_unref(ProfileUpdateType).EDUCATION, ''))),
                            ref_key: "educationModal",
                            ref: educationModal
                        }, null, 8, ["value"]),
                        _createVNode(QualificationModal, {
                            value: form.qualification,
                            onInput: onInputQualification,
                            onCancel: _cache[16] || (_cache[16] = ($event) => (setErrors(_unref(ProfileUpdateType).QUALIFICATION, ''))),
                            ref_key: "qualificationModal",
                            ref: qualificationModal
                        }, null, 8, ["value"]),
                        _createVNode(LanguageModal, {
                            value: form.language,
                            onInput: onInputLanguage,
                            onCancel: _cache[17] || (_cache[17] = ($event) => (setErrors(_unref(ProfileUpdateType).LANGUAGE, ''))),
                            ref_key: "languageModal",
                            ref: languageModal
                        }, null, 8, ["value"]),
                        _createVNode(IsPublicCareerModal, {
                            value: form.is_public_career,
                            errors: errors.is_public_career,
                            onInput: onSelectedIsPublicCareer,
                            onCancel: _cache[18] || (_cache[18] = ($event) => (setErrors(_unref(ProfileUpdateType).CAREER_PUBLIC_SETTING, ''))),
                            ref_key: "isPublicCareerModal",
                            ref: isPublicCareerModal
                        }, null, 8, ["value", "errors"]),
                        _createVNode(IsNotificationReceivingModal, {
                            value: form.is_notification_receiving,
                            errors: errors.is_notification_receiving,
                            onInput: onSelectedIsNotificationReceiving,
                            onCancel: _cache[19] || (_cache[19] = ($event) => (setErrors(_unref(ProfileUpdateType).IS_NOTIFICATION_RECEIVING, ''))),
                            ref_key: "isNotificationReceivingModal",
                            ref: isNotificationReceivingModal
                        }, null, 8, ["value", "errors"]),
                        _createElementVNode("div", _hoisted_71, [
                            _cache[79] || (_cache[79] = _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1)),
                            _createElementVNode("div", _hoisted_72, [
                                _createElementVNode("div", _hoisted_73, [
                                    _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                    _cache[78] || (_cache[78] = _createElementVNode("h2", null, "削除してもよろしいですか？", -1)),
                                    _createElementVNode("div", _hoisted_75, [
                                        _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                            _cache[77] || (_cache[77] = _createElementVNode("li", null, [
                                                _createElementVNode("p", { class: "bt_modal_close bt_clear" }, "キャンセル")
                                            ], -1)),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("p", {
                                                    class: "bt_modal_close bt_ok",
                                                    onClick: onDeleteCareer
                                                }, "OK")
                                            ])
                                        ]),
                                        _createElementVNode("p", {
                                            class: "bt_modal_close",
                                            ref_key: "careerDeleteModal",
                                            ref: careerDeleteModal,
                                            style: { "display": "none" }
                                        }, null, 512)
                                    ])
                                ])
                            ])
                        ]),
                        _createVNode(CareerModal, {
                            form: career.value,
                            errors: { started_at: errors.started_at, is_ended: errors.is_ended, ended_at: errors.ended_at, organization: errors.organization, department: errors.department, position: errors.position, experience_content: errors.experience_content },
                            onInput: onInputCareerModal,
                            onCancel: _cache[20] || (_cache[20] = ($event) => (setErrors(_unref(ProfileUpdateType).CAREER_UPDATE, ''))),
                            ref_key: "careerModal",
                            ref: careerModal
                        }, null, 8, ["form", "errors"])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
